// extracted by mini-css-extract-plugin
export default {"root":"ContentLayout_root__fCXBn","withActions":"ContentLayout_withActions__r2xsz","withTitle":"ContentLayout_withTitle__2RIaP"};